module.exports = __webpack_public_path__ + "img/Amazon.833578c7.svg";